import cloneDeep from "lodash/cloneDeep";
import { ENTITY_LABELS } from "components/FormerEditor/common/constants/entity";

export const SHORT_LINK_PRODUCT_REMOVAL = [
  {
    title: "Remove product",
    header: "Are you sure you want to remove this product?"
  }
];

export const COUPON_REMOVAL = [
  {
    title: "Remove coupon",
    header: "Are you sure you want to remove this coupon?"
  }
];

export const TAX_RATE_REMOVAL = [
  {
    title: "Remove tax rate",
    header: "Are you sure you want to remove this tax rate?"
  }
];

export const INTEGRATION_REMOVAL = [
  {
    title: "Remove integration",
    header: "Are you sure you want to remove this integration?"
  }
];

export const SHIPPING_RATE_REMOVAL = [
  {
    title: "Remove shipping rate",
    header: "Are you sure you want to remove this shipping rate?"
  }
];

export const SHORT_LINK_REMOVAL = [
  {
    title: "Remove payment link",
    header: "Are you sure you want to remove this payment link?"
  }
];

export const ATTACHMENT_REMOVAL = [
  {
    title: "Remove file",
    header: "Are you sure you want to remove this file?"
  }
];

export const INTEGRATION_DELETE = [
  {
    title: "Delete integration",
    header: "Are you sure you want to delete this integration?"
  }
];

export const DATASOURCE_REMOVAL = [
  {
    title: "Remove datasource",
    header: "Are you sure you want to remove this datasource?"
  }
];

export const COUPON_PROMOTION_CODE_REMOVAL = [
  {
    title: "Remove promotion code",
    header:
      "Are you sure you want to remove this promotion code from the coupon?"
  }
];

export const PRODUCT_PRICE_REMOVAL = [
  {
    title: "Remove price",
    header: "Are you sure you want to remove this price?"
  }
];

export const DISCONNECT_MERCHANT_ACCOUNT = [
  {
    title: "Disconnect merchant acount",
    header:
      "Without a connected merchant account, you will no longer be able to process payments on PriceBlocs. Are you sure you want to disconnect this merchant account?"
  }
];

export const DISCONNECT_INTEGRATION = [
  {
    title: "Disconnect integration",
    header:
      "Are you sure you want to disconnect this integration? You will no longer be able to use it as a source of data or trigger any actions within it from PriceBlocs."
  }
];

export const DELETE_ACCOUNT = {
  title: "Delete your account?",
  header:
    "Are you sure? We're sad to see you go, and want to make sure you're aware that this action can't be undone."
};

export const COMBINATION_CLEAR = [
  {
    title: "Clear combination",
    header: "Are you sure you want to clear this combination?"
  }
];

export const BLOCK_REMOVAL = [
  {
    title: "Remove block",
    header: "Are you sure you want to remove this block?"
  }
];

export const getBlockRemovalSlides = ({ uid }) => {
  const label = ENTITY_LABELS[uid] ? ENTITY_LABELS[uid].toLowerCase() : "block";

  return [
    {
      title: `Remove ${label}`,
      header: `Are you sure you want to remove this ${label}?`
    }
  ];
};

export const FIELD_REMOVAL = [
  {
    title: "Remove field",
    header: "Are you sure you want to remove this field?"
  }
];

export const getFieldRemovalSlides = (combination) => {
  const result = cloneDeep(FIELD_REMOVAL);
  if (combination) {
    result[0].header = [
      result[0].header,
      "This field will also be removed from the current checkout combination logic."
    ].join(" ");
  }

  return result;
};

export const FIELD_GROUP_REMOVAL = [
  {
    title: "Remove field group",
    header: "Are you sure you want to remove this field group?"
  }
];

export const getFieldGroupRemovalSlides = (combination) => {
  const result = cloneDeep(FIELD_GROUP_REMOVAL);
  if (combination) {
    result[0].header = [
      result[0].header,
      "All fields in this group will also be removed from the current checkout combination logic."
    ].join(" ");
  }

  return result;
};
